import Icon from '../../../../components/Icon'
import { Link as RrdLink, useLocation } from "react-router-dom";
import arrowFowardIcon from "../../../../assets/icons/arrow-foward.svg";
import {
  Flex
} from './styles'
import { connect } from 'react-redux';
import { useWindowSize } from '../../../../hooks/useWindowSize';

interface ComponentProps {
  path
}

const Component = ({
  path
}: ComponentProps) => {
  const { isMobile } = useWindowSize()
  const location = useLocation()

  return (
    <RrdLink
      to={{
        pathname: path,
        state: { from: location?.pathname }
      }}
      style={{
        color: "#2d3436",
        padding: "0px",
        textDecoration: "none",
        minWidth: 0,
        fontSize: 14,
        fontWeight: 500,
        ...(isMobile ? {
          border: "1px solid rgb(45, 52, 54)",
          color: "#2d3436",
          height: "40px",
          padding: "0px 12px",
          borderRadius: "6px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center"
        } : {})
      }}
    >
      <Flex style={{ gap: 4 }}>
        <span style={{ color: "#2d3436", }}>Ver más</span>
        {!isMobile && <Icon icon={arrowFowardIcon} size="18px" color="#2d3436" />}
      </Flex>
    </RrdLink>
  )
}


const state = ({ groupStore }) => {
  const { data: group, states: groupStates } = groupStore.group;

  return {
    group,
    groupStates,
  };
};

export default connect(state)(Component);